/*=====================================
    空白發票列表

    Author: Gray
    createtime: 2018 / 01 / 10
=====================================*/

/*--------------------------
    Import
--------------------------*/
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { parse } from 'qs';
import filter from 'lodash/filter';
import actionCreators from 'actions/creators';
import CupoyRouter from "components/commons/router/CupoyRouter";
import CupoySrefView from "components/commons/router/CupoySrefView";
import PagedList from 'components/commons/PagedList';
import EmptyInvoiceListHeader from './EmptyInvoiceListHeader';
import EmptyInvoiceListItem from './EmptyInvoiceListItem';

/*--------------------------
    Main Component
--------------------------*/
class EmptyInvoiceListView extends Component {

    // ------------------------------
    // constructor
    // ------------------------------
    constructor(props) {

        super(props);

        this.state = {
            page: 1,
            yearmonth: undefined,
            isFilterYearmonth: false,
        };

        this.onYearmonthChange = this.onYearmonthChange.bind(this);
        this.toggleIsFilterYearmonth = this.toggleIsFilterYearmonth.bind(this);
        this.onFilterChange = this.onFilterChange.bind(this);
        this.renderFilterContent = this.renderFilterContent.bind(this);
    }

    // ------------------------------
    // componentDidMount
    // ------------------------------
    componentDidMount() {

        this.init(this.props);
        this.getEmptyInvoiceYearmonthList();
    }

    // ------------------------------
    // componentWillReceiveProps
    // ------------------------------
    componentWillReceiveProps(nextProps) {

        this.init(nextProps);
    }

    // ------------------------------
    // init
    // ------------------------------
    init(props) {

        if (!props.match) {
            return;
        }

        const page = props.match.params.page;
        const location = props.location;
        const old_yearmonth = this.state.yearmonth;
        var yearmonth = undefined;
        var isFilterYearmonth = false;
        var isChange = false;

        if(location && location.search) {
            const querys = parse(location.search.substr(1));
            yearmonth = querys.yearmonth;

            if(yearmonth !== old_yearmonth) {
                isChange = true;
            }

            isFilterYearmonth = !!yearmonth;
        }

        isChange = isChange || this.state.page !== page;

        if (!isChange) {
            return;
        }

        this.setState({
            page: page,
            yearmonth: yearmonth,
            isFilterYearmonth: isFilterYearmonth,
        });
    }

    // ------------------------------
    // 取得空白發票存在的期別列表 
    // ------------------------------
    getEmptyInvoiceYearmonthList() {

        if(!Array.isArray(this.props.yearmonthList) || this.props.yearmonthList.length === 0) {
            this.props.emptyInvoiceActions.getEmptyInvoiceYearmonthList();
        }
    }

    // ------------------------------
    // 期別更動
    // ------------------------------
    onYearmonthChange(event) {

        var yearmonth = event.target.value;

        this.setState({
            yearmonth: yearmonth,
            isFilterYearmonth: !!yearmonth,
        }, () => {
            this.onFilterChange();
        })
    }

    // ------------------------------
    // 切換過濾期別
    // ------------------------------
    toggleIsFilterYearmonth(isFilterYearmonth) {

        this.setState({
            isFilterYearmonth: isFilterYearmonth,
        }, () => {
            this.onFilterChange();
        })
    }

    // ------------------------------
    // 任何過濾條件變動
    // ------------------------------
    onFilterChange() {

        const {
            yearmonth,
            isFilterYearmonth,
        } = this.state;

        var querys = {};

        if(isFilterYearmonth) {
            querys.yearmonth = yearmonth;
        }

        const statename = CupoyRouter.STATES.EMPTYINVOICE_LIST;
        const params = {
            page: 1,
        };

        this.props.webActions.cupoyStateGo(statename, params, querys);
    }

    // ------------------------------
    // render filter區塊
    // ------------------------------
    renderFilterContent(querys) {

        const {
            yearmonth,
        } = this.state;

        const {
            yearmonthList,
        } = this.props;

        return (
            <div className="form">
                <table className="form-table">
                    <tbody>
                        <tr className="form-row">
                            <td className="form-col label-text">發票期別</td>
                            <td className="form-col">
                                <div className="form-select fileter-large-content">
                                    <select value={yearmonth} onChange={(event) => this.onYearmonthChange(event)}>
                                        <option value={''} key={''}>---</option>
                                        {yearmonthList.map((_yearmonth, index)=> {
                                            return (<option value={_yearmonth} key={_yearmonth}>{_yearmonth}</option>)
                                        })}
                                    </select>
                                    <div className="select-arrow"><i className="zmdi zmdi-caret-down"></i></div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        )
    }

    // ------------------------------
    // render
    // ------------------------------
    render() {

        const { page } = this.state;
        const { location, pageLen, totalCount, yearmonthList } = this.props;
        const num_page = Number(page);

        var querys = {};

        if(location && location.search) {
            querys = parse(location.search.substr(1));
        }

        var renderFilterContent = null;

        if(yearmonthList.length > 0) {
            renderFilterContent = () => {
                return this.renderFilterContent(querys);
            }         
        }
    
        return (
            <div id="emptyInvoice">
                <div className="header-bar mix">
                    <h1 className="title">空白發票列表</h1>

                    <div className="button-group">
                        <CupoySrefView 
                            className="button blue" 
                            statename={CupoyRouter.STATES.ADD_EMPTYINVOICE}
                        >
                            上架空白發票
                        </CupoySrefView>
                    </div>
                </div>
                
                <PagedList
                    page={num_page}
                    pageLen={pageLen}
                    totalCount={totalCount}
                    colspan={4}
                    pageStateName={CupoyRouter.STATES.EMPTYINVOICE_LIST}
                    querys={querys}
                    getListItemFrom={(start, querys) => {
                        return this.props.emptyInvoiceActions.getEmptyInvoiceList({
                            start: start,
                            yearmonth: querys.yearmonth,
                        });
                    }}
                    getItemsInRanage={(start, end) => {
                        return filter(this.props.emptyInvoiceList, (item, index) => {
                            return Number(index) >= start && Number(index) < (end);
                        });
                    }}
                    renderItemHeaderRow={(item, index) => {
                        return <EmptyInvoiceListHeader />;
                    }}
                    renderItemRow={(item, index, start) => {
                        return <EmptyInvoiceListItem
                            key={index}
                            item={this.props.emptyInvoices[item]}
                            start={start}
                            index={start + index + 1}
                        />;
                    }}
                    renderFilterContent={renderFilterContent}
                />
            </div>
        );
    }

}

const mapStateToProps = function (state) {
    return {
        emptyInvoiceList: state.emptyInvoice.emptyInvoiceList,
        emptyInvoices: state.emptyInvoice.emptyInvoices,
        pageLen: state.emptyInvoice.pageLen,
        totalCount: state.emptyInvoice.totalCount,
        yearmonthList: state.emptyInvoice.yearmonthList,
    };
};

const mapActionToProps = function (dispatch) {
    return {
        webActions: bindActionCreators(actionCreators.webActionCreators, dispatch),
        emptyInvoiceActions: bindActionCreators(actionCreators.emptyInvoiceActionCreators, dispatch)
    };
};

export default connect(mapStateToProps, mapActionToProps, null, {
    withRef: true
})(EmptyInvoiceListView);


// WEBPACK FOOTER //
// ./src/components/emptyInvoice/EmptyInvoiceListView.jsx